import { useMutation } from "@tanstack/react-query";
import { useAuth } from "../../../../Context/AuthContext";
import { getCampaignMessageSummary } from "../api/campaignReportsApi";

export const useCampaignMessageSummary = () => {
  const auth = useAuth();
  const { token } = auth.getSessionData();

  return useMutation({
    mutationFn: async ({
      uidCampaign,
      idCampaignMessage,
      isEmail = false,
      type,
    }) => {
      return getCampaignMessageSummary({
        token,
        uidCampaign,
        idCampaignMessage,
        isEmail,
        isRcs: type === "rcs",
      }).then((response) => response.data);
    },
  });
};
